import SignUp from "../features/Auth/Component/SignUp";
import Navbar from "../features/Navbar/Navbar";

export default function SignUpPage() {
  return (
    <div>
      <Navbar></Navbar>
      <SignUp></SignUp>
    </div>
  );
}
